import styles from "../Post/PostFooter.module.css";
import { useRef, useEffect } from "react";

export default function UserListModel({
  userList,
  loading,
  isOpen,
  onClose,
  title,
  onUserClick,
  emptyMessage,
  hasMore,
  onLoadMore,
}) {
  const scrollRef = useRef(null);
  const scrollPosition = useRef(0);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollPosition.current;
    }
  }, [userList]);

  if (!isOpen) return null;

  return (
    <div className={styles.likesGlobalOverlay} onClick={onClose}>
      <div
        className={styles.likesGlobalModal}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.likesModalHeader}>
          <span>{title}</span>

          <button type="button" className={styles.closeBtn} onClick={onClose}>
            ✕
          </button>
        </div>

        <div
          ref={scrollRef}
          className={styles.likesModalBody}
          onScroll={(e) => {
            const el = e.target;

            // store scroll position
            scrollPosition.current = el.scrollTop;

            // infinite scroll trigger
            if (el.scrollHeight - el.scrollTop <= el.clientHeight + 5) {
              if (hasMore && !loading) {
                onLoadMore && onLoadMore();
              }
            }
          }}
        >
          {loading && userList.length === 0 ? (
            <p className="text-center py-3">Loading...</p>
          ) : userList.length ? (
            userList.map((user) => {
              console.log(user, "userlistmodel")
              return (
                <div
                  key={user?._id}
                  className={styles.likeUser}
                  onClick={() => onUserClick(user?._id)}
                >
                  <img
                    src={
                      user?.profilePic ||
                      "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                    }
                    alt="user"
                    onError={(e) => {
                      e.target.src =
                        "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                    }}
                  />
                  <span>{user?.fullName}</span>
                </div>
              );
            })
          ) : (
            <p className="text-center py-3">{emptyMessage}</p>
          )}

          {/* loader for pagination */}
          {loading && userList.length > 0 && (
            <p className="text-center py-2">Loading more...</p>
          )}
        </div>
      </div>
    </div>
  );
}
